import type { HttpClient } from '../http';
import { unwrap, type ApiEnvelope } from '../envelope';
import type { TeamMember } from '../types/domain';

export function platformTeamEndpoints(http: HttpClient) {
  return {
    list: () => http.get<ApiEnvelope<TeamMember[]>>('/v1/platform/team').then(unwrap),
    add: (email: string) => http.post<ApiEnvelope<TeamMember>>('/v1/platform/team', { email }).then(unwrap),
    revoke: (id: string) => http.del<ApiEnvelope<null>>(`/v1/platform/team/${id}`).then(unwrap),
  };
}
export type PlatformTeamEndpoints = ReturnType<typeof platformTeamEndpoints>;
